import { Tooltip } from 'react-tooltip'

type PlacesType =
  | 'top'
  | 'top-start'
  | 'top-end'
  | 'right'
  | 'right-start'
  | 'right-end'
  | 'bottom'
  | 'bottom-start'
  | 'bottom-end'
  | 'left'
  | 'left-start'
  | 'left-end'
type VariantType = 'dark' | 'light' | 'success' | 'warning' | 'error' | 'info'

interface ToolTipProps {
    id?: string
    place?: PlacesType
    className?: string
    variant?: VariantType
    clickable?: boolean
}
const ToolTip = ({id, place, className, variant, clickable}: ToolTipProps) => {
    return (
        <Tooltip id={id} place={place} className={'fs12-i fm-b ls08 wsPw zIdx1000 ' + className} variant={variant} clickable={clickable} offset={0} delayShow={0} delayHide={0} />
    )
}
export default ToolTip;